import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/ocorrencia-motivo',
  name: 'ocorrencia-motivo',
  component: Index,
  children: [
    { path: 'listar', name: 'ocorrencia-motivo-listar', component: Listar },
    { path: 'novo', name: 'ocorrencia-motivo-novo', component: Novo },
    { path: ':id', name: 'ocorrencia-motivo-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'ocorrencia-motivo-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/ocorrencia-motivo/routes.js